export const DEFAULT_TIMEZONE = 'Africa/Nairobi';

export function getBrowserTimezone() {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone || null;
    } catch {
        return null;
    }
}

export function getEffectiveTimezone(user) {
    const userTz = user?.unsafeMetadata?.timezone || null;
    return userTz || getBrowserTimezone() || DEFAULT_TIMEZONE;
}

export function formatUTCToZone(dateLike, timeZone, options = {}) {
    if (!dateLike) return '';
    const date = typeof dateLike === 'string' ? new Date(dateLike) : dateLike;
    const tz = timeZone || getBrowserTimezone() || DEFAULT_TIMEZONE;
    try {
        return new Intl.DateTimeFormat('en-US', { timeZone: tz, ...options }).format(date);
    } catch (err) {
        console.error(err);
        return date.toLocaleString();
    }
}
